import React, { Component } from 'react';
import $ from 'jquery';

class DynamicTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.table = null;
    }

    componentDidMount() {
        this.createDataTable();
    }

    createDataTable = () => {
        const { idTable = 'searchDataTable', getData, columns, columnDefs } = this.props;
        this.table = $(`#${idTable}`).DataTable({
            info: false,
            dom: '<"toolbar">rti',
            pagingType: "full_numbers",
            paging: true,
            searching: true,
            processing: true,
            serverSide: true,
            ajax: (dataTablesParams, callback) => {
                getData(dataTablesParams, (data) => {
                    callback(data);
                    this.getTableInfoResult();
                });
            },
            columns,
            columnDefs,
            responsive: true,
            autoWidth: false,
            language: {
                emptyTable: "No hay registros disponibles",
                zeroRecords: "No se encontraron registros coincidentes"
            }
        });
    };

    // Cambiar el tamaño de la página
    changePaging = (value) => {
        this.table.page.len(value ?? 10).draw();
    }

    // Cambiar la página
    changePage = (page) => {
        if (this.table) {
            this.table.page(page).draw('page');
        }
    }

    // Información de la tabla
    getTableInfoResult = () => {
        const { idTable = 'searchDataTable' } = this.props;
        const info = this.table.page.info();
        let num = 0;

        if (info && info.recordsDisplay !== 0) num = 1;

        const pageStart = info.page * info.length + num;
        const pageEnd = Math.min(pageStart + info.length - 1, info.recordsDisplay);
        $(`#tableInfo${idTable}`).text(`${pageStart} - ${pageEnd} de ${info.recordsDisplay}`);
    };

    render() {
        const { enableSearchInTable = false, idTable = 'searchDataTable', headers = [], onChangeSearch } = this.props;
        return (
            <>
                {/* Input de Búsqueda */}
                {enableSearchInTable &&
                    <div className="row">
                        <div className="col-6 col-md-6 mb-3">
                            <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2 w-100'
                                placeholder="Buscar en tabla"
                                autoComplete="off"
                                id={`searchData${idTable}`}
                                type='search'
                                aria-controls={idTable}
                                onChange={(e) => onChangeSearch(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') this.table.ajax.reload();
                                }}
                            />
                        </div>
                        <div className="col-6 col-md-6 mb-3">
                            <button className="btn btn-outline-dark" title="Actualizar" onClick={() => this.table.ajax.reload()}> <i className="fa fa-refresh" /> </button>
                        </div>
                    </div>
                }

                {/* Estructura de la tabla */}
                <div className="w-100 table-scroll" style={{ fontSize: '15px' }}>
                    <table id={idTable} className="display" style={{ width: '100%' }}>
                        <thead className="table-header font-weight-bold" style={{ backgroundColor: '#eabf28', color: 'white' }}>
                            <tr>
                                {headers.map((header, index) => {
                                    return <td key={index + idTable} className="text-center">{header.title}</td>
                                })}
                            </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                </div>

                {/* Control de paginación */}
                <div className="col-12 mt-3">
                    <div className="d-flex flex-wrap justify-content-end align-items-center">
                        <div className="form-group mb-2">
                            <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right registros" style={{ width: 195 }}>
                                Registros por página:
                            </label>
                        </div>
                        <div className="form-group mb-2">
                            <select
                                className="col col-form-label col-form-label-sm text-right"
                                style={{ width: 80 }}
                                aria-controls={idTable}
                                id={`changePaginateSelect${idTable}`}
                                onChange={(event) => this.changePaging(event.target.value)}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>&nbsp;&nbsp;
                        </div>
                        <div className="form-group mb-2">
                            <label htmlFor="colFormLabelSm" id={`tableInfo${idTable}`}
                                className="col-form-label col-form-label-sm">
                            </label>
                        </div>
                        <div className="d-flex align-items-center mb-2 flex-nowrap">
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Primera" onClick={() => this.changePage('first')}>
                            <i className="fas fa-chevron-left btn-first" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Anterior" onClick={() => this.changePage('previous')}>
                            <i className="fas fa-chevron-left" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Siguiente" onClick={() => this.changePage('next')}>
                            <i className="fas fa-chevron-right" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Última" onClick={() => this.changePage('last')}>
                            <i className="fas fa-chevron-right btn-last" />
                        </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default DynamicTable;